import { render, staticRenderFns } from "./DTSLists.vue?vue&type=template&id=3f400b43&"
import script from "./DTSLists.vue?vue&type=script&lang=js&"
export * from "./DTSLists.vue?vue&type=script&lang=js&"
import style0 from "./DTSLists.vue?vue&type=style&index=0&id=3f400b43&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports